import {AccessType} from '@/features/access-types/types'
import {CreatePlannedAccessFormValidationSchema} from '@/features/planned-accesses/formSchemas'
import {zodResolver} from '@hookform/resolvers/zod'
import {ReactNode, useMemo} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

export const CreatePlannedAccessesFormProvider = ({
    children,
    defaultProjectId,
    isMixedProject,
    defaultAbsenceAccesses
}: {
    children: ReactNode
    defaultProjectId?: string
    isMixedProject?: boolean
    defaultAbsenceAccesses?: AccessType[]
}) => {
    const defaultAccessesValues = useMemo(
        () => [
            {
                accessType: undefined,
                numberOfAccesses: undefined
            }
        ],
        [defaultAbsenceAccesses]
    )

    const form = useForm<CreatePlannedAccessFormValidationSchema>({
        mode: 'onBlur',
        resolver: zodResolver(CreatePlannedAccessFormValidationSchema),
        defaultValues: {
            projectId: defaultProjectId,
            isMixedProject,
            inPersonAccesses: [
                {
                    ...defaultAccessesValues[0],
                    frequency: 'weekly'
                }
            ],
            singleAccesses: defaultAccessesValues,
            absenceAccesses: defaultAccessesValues
        }
    })

    return <FormProvider {...form}>{children}</FormProvider>
}
